import React, { useState } from 'react';
import { ProcessedSuite, ISuiteArea, ISuiteAsset } from 'src/pages/Suite/Components/UnitImportDialogue/Hooks/BulkSaveSuiteAPITypes';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import './Hooks/UnitImportPreview.scss';

const PREVIEW_LIMIT = 5;

interface UnitImportPreviewProps {
  records: ProcessedSuite[];
}

const SuiteCard = ({ suite }: { suite: ProcessedSuite }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="unit-preview-card">
      <div
        className="unit-preview-card-header"
        onClick={() => setExpanded((prev) => !prev)}
      >
        <div className="unit-preview-card-identity">
          <span className="unit-preview-card-number">Unit {suite.Number}</span>
          {suite.Building && (
            <span className="unit-preview-card-meta">{suite.Building}</span>
          )}
          {suite.Level && (
            <span className="unit-preview-card-meta">Level {suite.Level}</span>
          )}
          <CategoryPill
            text={suite.Status}
            color="#f3f4f6"
            textColor="#374151"
            size="small"
          />
        </div>
        <div className="unit-preview-card-summary">
          <div className="unit-preview-area-pills">
            {suite.Areas.map((area: ISuiteArea) => (
              <span key={area.Name} className="unit-preview-area-pill">
                {area.Name}
                <span className="unit-preview-area-pill-count">
                  {area.Assets.length}
                </span>
              </span>
            ))}
          </div>
          <button className="unit-preview-card-toggle" type="button">
            {expanded ? '▲ Hide' : '▼ Assets'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="unit-preview-card-body">
          {suite.Areas.map((area: ISuiteArea) => (
            <div key={area.Name} className="unit-preview-area">
              <div className="unit-preview-area-name">{area.Name}</div>
              <div className="unit-preview-asset-list">
                {area.Assets.map((asset: ISuiteAsset) => (
                  <span key={asset.Name} className="unit-preview-asset-chip">
                    {asset.Name}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const UnitImportPreview = ({ records }: UnitImportPreviewProps) => {
  const preview: ProcessedSuite[] = records.slice(0, PREVIEW_LIMIT);

  return (
    <div className="unit-preview">
      <div className="unit-preview-label">
        Preview ({preview.length} of {records.length} unit{records.length !== 1 ? 's' : ''})
      </div>
      <div className="unit-preview-list">
        {preview.map((suite: ProcessedSuite) => (
          <SuiteCard key={`${suite.Building}-${suite.Number}`} suite={suite} />
        ))}
      </div>
    </div>
  );
};

export default UnitImportPreview;